import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";

import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { Outlet, RouterProvider, createHashRouter } from "react-router";
import App from "./App";
import { registerLocalIcons } from "./components/icon";
import PageError from "./pages/sys/error/PageError";
import { routesSection } from "./routes/sections";
import { observeAllVitals, generatePerformanceReport } from "./utils/performance";

await registerLocalIcons();

// 性能监控：监控所有 Web Vitals
if (typeof window !== 'undefined') {
	observeAllVitals((metric) => {
		// 开发环境输出到控制台
		if (import.meta.env.DEV) {
			console.log(`📊 ${metric.name}: ${metric.value.toFixed(2)}ms (${metric.rating})`);
		}

		// 生产环境可以发送到分析服务
		// 例如: Google Analytics, Vercel Analytics 等
		if (typeof (window as any).gtag !== 'undefined') {
			(window as any).gtag('event', metric.name, {
				value: Math.round(metric.value),
				metric_rating: metric.rating,
				event_category: 'Web Vitals',
			});
		}
	});

	// 页面卸载时生成性能报告
	window.addEventListener('beforeunload', () => {
		if (import.meta.env.DEV) {
			generatePerformanceReport();
		}
	});
}

const router = createHashRouter([
	{
		Component: () => (
			<App>
				<Outlet />
			</App>
		),
		errorElement: <ErrorBoundary fallbackRender={PageError} />,
		children: routesSection,
	},
]);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<RouterProvider router={router} />);
